import { InputSkeleton } from '@/_components';
import { CardContainer, FormLayout, StickyPageHeaderSkeletonWithButtons } from '@/_containers';

export default function Loading() {
  return (
    <>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={0} withBreadcrumb />
      <CardContainer>
        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
        </FormLayout>
      </CardContainer>
    </>
  );
}
